import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingCustomDataConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingCustomDataConfigEntity
